import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initGA, gaPageView } from "../lib/ga";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem("analytics_session");
  if (!sessionId) {
    sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem("analytics_session", sessionId);
  }
  return sessionId;
};

// Track a page view
const trackPageView = async (url, title) => {
  try {
    const payload = {
      page_url: url.split(/[?#]/)[0],
      page_title: title || document.title,
      referrer: document.referrer ? document.referrer.split(/[?#]/)[0] : null,
      user_agent: navigator.userAgent,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      language: navigator.language,
      session_id: getSessionId()
    };

    const data = JSON.stringify(payload);
    const url_endpoint = `${API}/analytics/track`;
    
    // Use fetch without credentials mode
    fetch(url_endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
      keepalive: true,
      mode: 'cors'
    }).catch(() => {}); // Silently fail
  } catch (e) {
    // Silently fail - don't break the app for analytics
    console.debug("Analytics tracking failed:", e);
  }
};

export default function Analytics() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    // Only track if path changed (avoid double tracking)
    if (lastPath.current !== location.pathname) {
      lastPath.current = location.pathname;
      
      // Small delay to ensure page title is updated
      setTimeout(() => {
        initGA();
        gaPageView(location.pathname, document.title);
        trackPageView(
          window.location.href,
          document.title
        );
      }, 100);
    }
  }, [location]);


  return null; // This component doesn't render anything
}
